export default {
  toasts: {
    auth_token_invalid: 'Auth token invalid',
    host_access_refused: 'This address belongs to a partner your account is not part of. Sign in on your own address.',
  },
};
